module.exports = {
    'color-1': {
        name: 'Color 1',
        fillAll: true,
        placeholderColor: 'rgb(211,207,201)',
        border: [
          [0, 0],
          [0, 2],
          [2, 2],
          [2, 0],
          [0, 0],
    
          [0, 2],
          [0, 4],
          [2, 4],
          [2, 2],
          [0, 2],
    
          [0, 8],
          [2, 8],
          [2, 6],
          [0, 6],
          [0, 8],
    
          [0, 10],
          [2, 10],
          [2, 8],
          [0, 8],
    
          [0, 14],
          [2, 14],
          [2, 12],
          [0, 12],
          [0, 14],
          [0, 16],
          [2, 16],
          [2, 14],
          [0, 14],
    
          [0, 20],
          [2, 20],
          [2, 18],
          [0, 18],
          [0, 20],
          [0, 22],
          [2, 22],
          [2, 20],
          [ 0, 20],
    
          [0, 26],
          [2, 26],
          [2, 24],
          [0, 24],
    
          [0, 28],
          [2, 28],
          [2, 26],
          [0, 26],
    
          [0, 32],
          [2, 32],
          [2, 30],
          [0, 30],
          [0, 32],
          [0, 34],
          [2, 34],
          [2, 32],
          [0, 32],
          [0, 0],
    
          [4, 0],
          [4, 2],
          [2, 2],
          [2, 0],
          [4, 0],
          
          [4, 2],
          [4, 4],
          [2, 4],
          [2, 2],
    
          [2, 6],
          [4, 6],
          [4, 8],
          [2, 8],
          [2, 6],
          [2, 8],
          [4, 8],
          [4, 10],
          [2, 10],
    
          [2, 12],
          [4, 12],
          [4, 14],
          [2, 14],
          [2, 12],
    
          [2, 14],
          [4, 14],
          [4, 16],
          [2, 16],
          [2, 14],
    
          [2, 18],
          [4, 18],
          [4, 20],
          [2, 20],
          [2, 18],
          [2, 20],
          [4, 20],
          [4, 22],
          [2, 22],
          [2, 20],
    
          [2, 24],
          [4, 24],
          [4, 26],
          [2, 26],
          [2, 24],
          [2, 26],
          [4, 26],
          [4, 28],
          [2, 28],
          [2, 26],
          [2, 24],
    
          [2, 30],
          [4, 30],
          [4, 32],
          [2, 32],
          [2, 30],
          [2, 32],
          [4, 32],
          [4, 34],
          [2, 34],
          [2, 32],
    
          [2, 0],
    
          [8, 0],
          [8, 2],
          [6, 2],
          [6, 0],
          [8, 0],
          [8, 2],
          [8, 4],
          [6, 4],
          [6, 2],
    
          [6, 6],
          [8, 6],
          [8, 8],
          [6, 8],
          [6, 6],
          [6, 8],
          [8, 8],
          [8, 10],
          [6, 10],
          [6, 8],
    
          [6, 12],
          [8, 12],
          [8, 14],
          [6, 14],
          [6, 12],
          [6, 14],
          [8, 14],
          [8, 16],
          [6, 16],
          [6, 14],
    
          [6, 18],
          [8, 18],
          [8, 20],
          [6, 20],
          [6, 18],
          [6, 20],
          [8, 20],
          [8, 22],
          [6, 22],
          [6, 20],
    
          [6, 24],
          [8, 24],
          [8, 26],
          [6, 26],
          [6, 24],
          [6, 26],
          [8, 26],
          [8, 28],
          [6, 28],
          [6, 26],
          [6, 24],
    
          [6, 30],
          [8, 30],
          [8, 32],
          [6, 32],
          [6, 30],
          [6, 32],
          [8, 32],
          [8, 34],
          [6, 34],
          [6, 32],
               
          [6, 0],
    
          [10, 0],
          [10, 2],
          [8, 2],
          [8, 0],
          [10, 0],
          [10, 2],
          [10, 4],
          [8, 4],
          [8, 2],
          [8, 4],
    
          [8, 6],
          [10, 6],
          [10, 8],
          [8, 8],
          [8, 6],
          [8, 8],
          [10, 8],
          [10, 10],
          [8, 10],
          [8, 8],
          [8, 6],
    
          [8, 12],
          [10, 12],
          [10, 14],
          [8, 14],
          [8, 12],
          [8, 14],
          [10, 14],
          [10, 16],
          [ 8, 16],
          [8, 14],
          [8, 12],
    
          [8, 18],
          [10, 18],
          [10, 20],
          [8, 20],
          [8, 18],
          [8, 20],
          [10, 20],
          [10, 22],
          [ 8, 22],
          
          [8, 24],
          [10, 24],
          [10, 26],
          [8, 26],
          [8, 24],
          [8, 26],
          [10, 26],
          [10, 28],
          [ 8, 28],
          [8, 26],
    
          [8, 30],
          [10, 30],
          [10, 32],
          [8, 32],
          [8, 30],
          [8, 32],
          [10, 32],
          [10, 34],
          [ 8, 34],
          [8, 32],
          [8, 30],
    
          [8, 0],
    
          [14, 0],
          [14, 2],
          [12, 2],
          [12, 0],
          [14, 0],
          [14, 2],
          [14, 4],
          [12, 4],
          [12, 2],
          [12, 4],
    
          [12, 6],
          [14, 6],
          [14, 8],
          [12, 8],
          [12, 6],
          [12, 8],
          [14, 8],
          [14, 10],
          [12, 10],
          [12, 8],
          [12, 6],
    
          [12, 12],
          [14, 12],
          [14, 14],
          [12, 14],
          [12, 12],
          [12, 14],
          [14, 14],
          [14, 16],
          [12, 16],
          [12, 14],
    
          [12, 18],
          [14, 18],
          [14, 20],
          [12, 20],
          [12, 18],
          [12, 20],
          [14, 20],
          [14, 22],
          [12, 22],
    
          [12, 24],
          [14, 24],
          [14, 26],
          [12, 26],
          [12, 24],
          [12, 26],
          [14, 26],
          [14, 28],
          [12, 28],
          [12, 26],
    
          [12, 30],
          [14, 30],
          [14, 32],
          [12, 32],
          [12, 30],
          [12, 32],
          [14, 32],
          [14, 34],
          [12, 34],
    
          [12, 0],
    
          [16, 0],
          [16, 2],
          [14, 2],
          [14, 0],
          [16, 0],
          [16, 2],
          [16, 4],
          [14, 4],
    
          [14, 6],
          [16, 6],
          [16, 8],
          [14, 8],
          [14, 6],
          [14, 8],
          [16, 8],
          [16, 10],
          [14, 10],
          [14, 8],
    
          [14, 12],
          [16, 12],
          [16, 14],
          [14, 14],
          [14, 12],
          [14, 14],
          [16, 14],
          [16, 16],
          [14, 16],
          [14, 14],
    
          [14, 18],
          [16, 18],
          [16, 20],
          [14, 20],
          [14, 18],
          [14, 20],
          [16, 20],
          [16, 22],
          [14, 22],
    
          [14, 24],
          [16, 24],
          [16, 26],
          [14, 26],
          [14, 24],
          [14, 26],
          [16, 26],
          [16, 28],
          [14, 28],
          [14, 26],
    
          [14, 30],
          [16, 30],
          [16, 32],
          [14, 32],
          [14, 30],
          [14, 32],
          [16, 32],
          [16, 34],
          [14, 34],
          [14, 0],
    
          [20, 0],
          [20, 2],
          [18, 2],
          [18, 0],
          [20, 0],
          [20, 2],
          [20, 4],
          [18, 4],
          [18, 2],
          [18, 4],
    
          [18, 6],
          [20, 6],
          [20, 8],
          [18, 8],
          [18, 6],
          [18, 8],
          [20, 8],
          [20, 10],
          [18, 10],
          [18, 8],
    
          [18, 12],
          [20, 12],
          [20, 14],
          [18, 14],
          [18, 12],
          [18, 14],
          [20, 14],
          [20, 16],
          [18, 16],
          [18, 14],
          [18, 12],
          [18, 10],
    
          [18, 18],
          [20, 18],
          [20, 20],
          [18, 20],
          [18, 18],
          [18, 20],
          [20, 20],
          [20, 22],
          [18, 22],
          [18, 20],
          [18, 18],
    
          [18, 24],
          [20, 24],
          [20, 26],
          [ 18, 26],
          [18, 24],
          [18, 26],
          [20, 26],
          [20, 28],
          [18, 28],
          [18, 26],
    
          [18, 30],
          [20, 30],
          [20, 32],
          [18, 32],
          [18, 30],
          [18, 32],
          [20, 32],
          [20, 34],
          [18, 34],
          [18, 32],
          [18, 30],
          [18, 0],
    
          [22, 0],
          [22, 2],
          [20, 2],
          [20, 0],
          [22, 0],
          [22, 2],
          [22, 4],
          [20, 4],
          [20, 2],
          [ 20, 4],
    
          [20, 6],
          [22, 6],
          [22, 8],
          [20, 8],
          [20, 6],
          [20, 8],
          [22, 8],
          [22, 10],
          [20, 10],
          [20, 8],
    
          [20, 12],
          [22, 12],
          [22, 14],
          [20, 14],
          [20, 12],
          [20, 14],
          [22, 14],
          [22, 16],
          [20, 16],
          [20, 14],
    
          [20, 18],
          [22, 18],
          [22, 20],
          [20, 20],
          [20, 18],
          [20, 20],
          [22, 20],
          [22, 22],
          [20, 22],
          [20, 20],
          [   20, 18],
    
          [20, 24],
          [22, 24],
          [22, 26],
          [20, 26],
          [20, 24],
          [20, 26],
          [22, 26],
          [22, 28],
          [20, 28],
          [20, 26],
          [20, 24],
          [20, 22],
    
          [20, 30],
          [22, 30],
          [22, 32],
          [20, 32],
          [20, 30],
          [20, 32],
          [22, 32],
          [22, 34],
          [20, 34],
          [20, 32],
          [20, 30],
    
          [20, 0],
    
          [26, 0],
          [26, 2],
          [24, 2],
          [24, 0],
          [26, 0],
          [26, 2],
          [26, 4],
          [24, 4],
          [24, 2],
          [24, 4],
    
          [24, 6],
          [26, 6],
          [26, 8],
          [24, 8],
          [24, 6],
          [24, 8],
          [26, 8],
          [26, 10],
          [24, 10],
          [24, 8],
    
          [24, 12],
          [26, 12],
          [26, 14],
          [24, 14],
          [24, 12],
          [24, 14],
          [26, 14],
          [26, 16],
          [24, 16],
          [24, 14],
    
          [24, 18],
          [26, 18],
          [26, 20],
          [24, 20],
          [24, 18],
          [24, 20],
          [26, 20],
          [26, 22],
          [24, 22],
          [24, 20],
    
          [24, 24],
          [26, 24],
          [26, 26],
          [24, 26],
          [24, 24],
          [24, 26],
          [26, 26],
          [26, 28],
          [24, 28],
          [24, 26],
    
          [24, 30],
          [26, 30],
          [26, 32],
          [24, 32],
          [24, 30],
          [24, 32],
          [26, 32],
          [26, 34],
          [24, 34],
          [24, 32],
          [24, 30],
    
          [24, 0],
    
          [28, 0],
          [28, 2],
          [26, 2],
          [26, 0],
          [28, 0],
          [28, 2],
          [28, 4],
          [26, 4],
          [26, 2],
          [26, 4],
    
          [26, 6],
          [28, 6],
          [28, 8],
          [26, 8],
          [26, 6],
          [26, 8],
          [28, 8],
          [28, 10],
          [26, 10],
          [26, 8],
          [26, 6],
    
          [26, 12],
          [28, 12],
          [28, 14],
          [26, 14],
          [26, 12],
          [26, 14],
          [28, 14],
          [28, 16],
          [26, 16],
          [26, 14],
          [26, 12],
    
          [26, 18],
          [28, 18],
          [28, 20],
          [26, 20],
          [26, 18],
          [26, 20],
          [28, 20],
          [28, 22],
          [26, 22],
          [26, 20],
          [26, 18],
    
          [26, 24],
          [28, 24],
          [28, 26],
          [26, 26],
          [26, 24],
          [26, 26],
          [28, 26],
          [28, 28],
          [26, 28],
          [26, 26],
          [26, 24],
    
          [26, 30],
          [28, 30],
          [28, 32],
          [26, 32],
          [26, 30],
          [26, 32],
          [28, 32],
          [28, 34],
          [26, 34],
          [26, 32],
          [26, 30],
    
          [26, 0],
    
          [32, 0],
          [32, 2],
          [30, 2],
          [30, 0],
          [32, 0],
          [32, 2],
          [32, 4],
          [30, 4],
          [30, 2],
          [30, 4],
    
          [30, 6],
          [32, 6],
          [32, 8],
          [30, 8],
          [30, 6],
          [30, 8],
          [32, 8],
          [ 32, 10],
          [30, 10],
          [30, 8],
          [30, 6],
          [30, 4],
    
          [30, 12],
          [32, 12],
          [32, 14],
          [30, 14],
          [30, 12],
          [30, 14],
          [32, 14],
          [32, 16],
          [30, 16],
          [30, 14],
    
          [30, 18],
          [32, 18],
          [32, 20],
          [30, 20],
          [30, 18],
          [30, 20],
          [32, 20],
          [32, 22],
          [30, 22],
          [30, 20],
    
          [30, 24],
          [32, 24],
          [32, 26],
          [30, 26],
          [30, 24],
          [30, 26],
          [32, 26],
          [32, 28],
          [30, 28],
          [30, 26],
    
          [30, 30],
          [32, 30],
          [32, 32],
          [30, 32],
          [30, 30],
          [30, 32],
          [32, 32],
          [32, 34],
          [30, 34],
          [30, 32],
          [30, 30],
          [30, 0],
          [0, 0],
    
          [34, 0],
          [34, 2],
          [32, 2],
          [32, 0],
          [34, 0],
          [34, 2],
          [34, 4],
          [32, 4],
          [32, 2],
    
          [32, 6],
          [34, 6],
          [34, 8],
          [32, 8],
          [32, 6],
          [32, 8],
          [34, 8],
          [34, 10],
          [32, 10],
          [32, 8],
    
          [32, 12],
          [34, 12],
          [34, 14],
          [32, 14],
          [32, 12],
          [32, 14],
          [34, 14],
          [34, 16],
          [32, 16],
          [32, 14],
          [32, 12],
    
          [32, 18],
          [34, 18],
          [34, 20],
          [32, 20],
          [32, 18],
          [32, 20],
          [34, 20],
          [34, 22],
          [32, 22],
          [32, 20],
          [32, 18],
          [32, 16],
    
          [32, 24],
          [34, 24],
          [34, 26],
          [32, 26],
          [32, 24],
          [32, 26],
          [34, 26],
          [34, 28],
          [32, 28],
          [32, 26],
          [32, 24],
          [32, 22],
    
          [32, 30],
          [34, 30],
          [34, 32],
          [32, 32],
          [32, 30],
          [32, 32],
          [34, 32],
          [34, 34],
          [32, 34],
          [32, 32],
          [32, 30],
          [32, 0]
    
        ]
    },
    'color-2': {
        name: 'Color 2',
        fillAll: true,
        placeholderColor: 'rgb(106,105,111)',
        border: [
          [0, 0],
          [0, 4], 
          [2, 4],
          [2, 6],
          [0, 6],
          [0, 4],
    
          [2, 4],
          [4, 4],
          [4, 6],
          [2, 6],
          [2, 4],
          [0, 4],
          [0, 0],
    
          [6, 0],
          [6, 2],
          [4, 2],
          [4, 0],
          [6, 0],
          [6, 2],
          [6, 4],
          [4, 4],
          [4, 2],
          [4, 4],
          [6, 4],
          [6, 6],
          [4, 6],
          [4, 4],
          [4, 6],
          [6, 6],
          [6, 8],
          [4, 8],
          [4, 6],
          [4, 8],
          [6, 8],
          [ 6, 10],
          [4, 10],
         
          [4, 10],
          [4, 12],
          [6, 12],
          [6, 14],
          [4, 14],
          [4, 12],
          [4, 14],
          [6, 14],
          [6, 16],
          [4, 16],
          [4, 14],
          [4, 16],
          [6, 16],
          [6, 18],
          [4, 18],
          [4, 16],
          [4, 18],
          [6, 18],
          [6, 20],
          [4, 20],
          [4, 18],
          [4, 20],
          [6, 20],
          [6, 22],
          [4, 22],
         
          [4, 24],
          [6, 24],
          [6, 26],
          [4, 26],
          [4, 24],
          [4, 26],
          [6, 26],
          [6, 28],
          [4, 28],
          [4, 26],
          [4, 28],
          [6, 28],
          [6, 30],
          [4, 30],
          [4, 28],
          [4, 30],
          [6, 30],
          [6, 32],
          [4, 32],
          [4, 30],
          [4, 32],
          [6, 32],
          [6, 34],
          [4, 34],
          [4, 32],
          [4, 34],
          [4, 0],
    
          [8, 0],
    
          [8, 4], 
          [8, 6],
          [6, 6],
          [6, 4],
          [8, 4],
    
          [10, 4], 
          [10, 6],
          [8, 6],
          [8, 4],
    
          [12, 4], 
          [12, 6],
          [10, 6],
          [10, 4],
    
          [14, 4], 
          [14, 6],
          [12, 6],
          [12, 4],
    
          [16, 4], 
          [16, 6],
          [14, 6],
          [14, 4],
    
          [20, 4], 
          [20, 6],
          [18, 6],
          [18, 4],
          
          [22, 4], 
          [22, 6],
          [20, 6],
          [20, 4],
          
          [24, 4], 
          [24, 6],
          [22, 6],
          [22, 4],
          
          [26, 4], 
          [26, 6],
          [24, 6],
          [24, 4],
    
          [28, 4], 
          [28, 6],
          [26, 6],
          [26, 4],
    
          [32, 4], 
          [32, 6],
          [30, 6],
          [30, 4],
          [34, 4], 
          [34, 6],
          [32, 6],
          [32, 4],
          [36, 4], 
          [36, 6],
          [34, 6],
          [34, 4],
    
          [8, 4],
          [8, 0]
        ]
    },
    'color-3': {
        name: 'Color 3',
        fillAll: true,
        placeholderColor: 'rgb(152,150,156)',
        border: [
          [0, 0],
          [0, 10],
          [2, 10],
          [2, 12],
          [0, 12],
          [0, 10],
          [4, 10],
          [4, 12],
          [2, 12],
          [2, 10],
          [6, 10],
          [6, 12],
          [4, 12],
          [4, 10],
          [8, 10],
          [8, 12],
          [6, 12],
          [6, 10],
          [10, 10],
          [10, 12],
          [ 8, 12],
          [8, 10],
          [0, 10],
    
          [0, 0],
    
          [12, 0],
          [12, 2],
          [10, 2],
          [10, 0],
          [12, 0],
          [12, 2],
          [12, 4],
          [10, 4],
          [10, 2],
          [10, 4],
    
          [10, 6],
          [12, 6],
          [12, 8],
          [10, 8],
          [10, 6],
          [10, 8],
          [12, 8],
          [12, 10],
          [10, 10],
          [10, 8],
    
          [10, 10],
          [12, 10],
          [12, 12],
          [10, 12],
          [10, 10],
    
          [10, 12],
          [12, 12],
          [12, 14],
          [10, 14],
          [10, 12],
          [10, 14],
          [12, 14],
          [12, 16],
          [10, 16],
    
          [10, 18],
          [12, 18],
          [12, 20],
          [10, 20],
          [10, 18],
    
          [10, 20],
          [12, 20],
          [12, 22],
          [10, 22],
          [12, 22],
          [12, 24],
          [10, 24],
          [10, 22],
    
          [10, 24],
          [12, 24],
          [12, 26],
          [10, 26],
          [10, 24],
          
          [10, 26],
          [12, 26],
          [12, 28],
          [10, 28],
          [10, 26],
    
          [10, 30],
          [12, 30],
          [12, 32],
          [10, 32],
          [10, 30],
          [10, 32],
          [12, 32],
          [12, 34],
          [10, 34],
          [10, 32],
          [10, 34],
          [12, 34],
          [12, 36],
          [10, 36],
          [10, 34],
          [10, 0],
    
          [12, 0],
          [12, 10], 
          [14, 10],
          [14, 12],
          [12, 12],
          [12, 10],
          
          [14, 10], 
          [16, 10],
          [16, 12],
          [14, 12],
          [14, 10],
    
          [16, 10], 
          [18, 10],
          [18, 12],
          [16, 12],
          [16, 10],
    
          [18, 10], 
          [20, 10],
          [20, 12],
          [18, 12],
          [18, 10],
    
          [20, 10], 
          [22, 10],
          [22, 12],
          [20, 12],
          [20, 10],
    
          [24, 10], 
          [26, 10],
          [26, 12],
          [24, 12],
          [24, 10],
    
          [26, 10], 
          [28, 10],
          [28, 12],
          [26, 12],
          [26, 10],
    
          [28, 10], 
          [30, 10],
          [30, 12],
          [28, 12],
          [28, 10],
    
          [30, 10], 
          [32, 10],
          [32, 12],
          [30, 12],
          [30, 10],
    
          [32, 10], 
          [34, 10],
          [34, 12],
          [32, 12],
          [32, 10],
    
          [10, 10],
          [10,0]
        ]
    },
    'color-4': {
        name: 'Color 4',
        fillAll: true,
        placeholderColor: 'rgb(149,148,144)',
        border: [
          [0, 0],
          [0, 16],
          [2, 16],
          [2, 18],
          [0, 18],
          [0, 16],
          [4, 16],
          [4, 18],
          [2, 18],
          [2, 16],
    
          [8, 16],
          [8, 18],
          [6, 18],
          [6, 16],
          [8, 16],
    
          [10, 16],
          [10, 18],
          [8, 18],
          [8, 16],
          [10, 16],
    
          [12, 16],
          [12, 18],
          [10, 18],
          [10, 16],
          [12, 16],
    
          [14, 16],
          [14, 18],
          [12, 18],
          [12, 16],
          [14, 16],
    
          [16, 16],
          [16, 18],
          [14, 18],
          [14, 16],
          [16, 16],
    
          [0, 16],
          [0, 0],
          [18, 0],
          [18, 2],
          [16, 2],
          [16, 0],
          [18, 0],
    
          [18, 2],
          [18, 4],
          [16, 4],
          [16, 2],
    
          [16, 4],
          [18, 4],
          [18, 6],
          [16, 6],
          [16, 4],
    
          [16, 6],
          [18, 6],
          [18, 8],
          [16, 8],
          [16, 6],
          [16, 8],
          [18, 8],
          [18, 10],
          [16, 10],
          [16, 8],
    
          [16, 12],
          [18, 12],
          [18, 14],
          [16, 14],
          [16, 12],
    
          [16, 14],
          [18, 14],
          [18, 16],
          [16, 16],
          [16, 14],
          [16, 16],
          [18, 16],
          [18, 18],
          [16, 18],
          [16, 16],
    
          [16, 18],
          [18, 18],
          [18, 20],
          [16, 20],
          [16, 18],
    
          [16, 20],
          [18, 20],
          [18, 22],
          [16, 22],
          [16, 20],
    
          [16, 24],
          [18, 24],
          [18, 26],
          [16, 26],
          [16, 24],
    
          [16, 26],
          [18, 26],
          [18, 28],
          [16, 28],
          [16, 26],
    
          [16, 28],
          [18, 28],
          [18, 30],
          [16, 30],
          [16, 28],
    
          [16, 30],
          [18, 30],
          [18, 32],
          [16, 32],
          [16, 30],
    
          [16, 32],
          [18, 32],
          [18, 34],
          [16, 34],
          [16, 32],
    
          [16, 0],
          [18, 0],
          [18, 16], 
          [20, 16],
          [20, 18],
          [18, 18],
          [18, 16],
    
          [20, 16], 
          [22, 16],
          [22, 18],
          [20, 18],
          [20, 16],
    
          [22, 16], 
          [24, 16],
          [24, 18],
          [22, 18],
          [22, 16],
    
          [24, 16], 
          [26, 16],
          [26, 18],
          [24, 18],
          [24, 16],
    
          [26, 16], 
          [28, 16],
          [28, 18],
          [26, 18],
          [26, 16],
    
          [30, 16], 
          [32, 16],
          [32, 18],
          [30, 18],
          [30, 16],
    
          [32, 16], 
          [34, 16],
          [34, 18],
          [32, 18],
          [32, 16],
    
          [34, 16], 
          [36, 16],
          [36, 18],
          [34, 18],
          [34, 16],
          [16, 16],
          [16, 0]
    
        ]
    },
    'color-5': {
        name: 'Color 5',
        fillAll: true,
        placeholderColor: 'rgb(63,67,72)',
        border: [
          [0, 0],
          [0, 22],
          [2, 22],
          [2, 24],
          [0, 24],
          [0, 22],
          [2, 22],
          [4, 22],
          [4, 24],
          [2, 24],
          [2, 22],
    
          [4, 22],
          [6, 22],
          [6, 24],
          [4, 24],
          [4, 22],
    
          [6, 22],
          [8, 22],
          [8, 24],
          [6, 24],
          [6, 22],
    
          [8, 22],
          [10, 22],
          [10, 24],
          [8, 24],
          [8, 22],
    
          [12, 22],
          [14, 22],
          [14, 24],
          [12, 24],
          [12, 22],
    
          [14, 22],
          [16, 22],
          [16, 24],
          [14, 24],
          [14, 22],
    
          [16, 22],
          [18, 22],
          [18, 24],
          [16, 24],
          [16, 22],
    
          [18, 22],
          [20, 22],
          [20, 24],
          [18, 24],
          [18, 22],
    
          [20, 22],
          [22, 22],
          [22, 24],
          [20, 24],
          [20, 22],
          [0, 22],
          [0, 0],
    
          [22, 0],
          [22, 2],
          [24, 2],
          [24, 0],
          [22, 0],
          
          [22, 2],
          [22, 4],
          [24, 4],
          [24, 2],
          [22, 2],
    
          [22, 6],
          [22, 8],
          [24, 8],
          [24, 6],
          [22, 6],
    
          [22, 8],
          [22, 10],
          [24, 10],
          [24, 8],
          [22, 8],
    
          [22, 10],
          [22, 12],
          [24, 12],
          [24, 10],
          [22, 10],
    
          [22, 12],
          [22, 14],
          [24, 14],
          [24, 12],
          [22, 12],
    
          [22, 14],
          [22, 16],
          [24, 16],
          [24, 14],
          [22, 14],
    
          [22, 18],
          [22, 20],
          [24, 20],
          [24, 18],
          [22, 18],
    
          [22, 20],
          [22, 22],
          [24, 22],
          [24, 20],
          [22, 20],
    
          [22, 22],
          [22, 24],
          [24, 24],
          [24, 22],
          [22, 22],
    
          [22, 24],
          [22, 26],
          [24, 26],
          [24, 24],
          [22, 24],
    
          [22, 26],
          [22, 28],
          [24, 28],
          [24, 26],
          [22, 26],
    
          [22, 30],
          [22, 32],
          [24, 32],
          [24, 30],
          [22, 30],
    
          [22, 32],
          [22, 34],
          [24, 34],
          [24, 32],
          [22, 32],
    
          [22, 34],
          [22, 36],
          [24, 36],
          [24, 34],
          [22, 34],
          [22, 0],
    
          [24, 0],
          [24, 22],
          [26, 22],
          [26, 24],
          [24, 24],
          [24, 22],
    
          [26, 22],
          [28, 22],
          [28, 24],
          [26, 24],
          [26, 22],
    
          [28, 22],
          [30, 22],
          [30, 24],
          [28, 24],
          [28, 22],
    
          [30, 22],
          [32, 22],
          [32, 24],
          [30, 24],
          [30, 22],
    
          [32, 22],
          [34, 22],
          [34, 24],
          [32, 24],
          [32, 22],
    
          [24, 22],
          [24, 0]
        ]
    },
    'color-6': {
        name: 'Color 6',
        fillAll: true,
        placeholderColor: 'rgb(63,67,72)',
        border: [
          [0, 0],
          [0, 28],
          [2, 28],
          [2, 30],
          [0, 30],
          [0, 28],
    
          [2, 28],
          [4, 28],
          [4, 30],
          [2, 30],
          [2, 28],
    
          [6, 28],
          [8, 28],
          [8, 30],
          [6, 30],
          [6, 28],
    
          [8, 28],
          [10, 28],
          [10, 30],
          [8, 30],
          [8, 28],
    
          [10, 28],
          [12, 28],
          [12, 30],
          [10, 30],
          [10, 28],
    
          [12, 28],
          [14, 28],
          [14, 30],
          [12, 30],
          [12, 28],
    
          [14, 28],
          [16, 28],
          [16, 30],
          [14, 30],
          [14, 28],
    
          [18, 28],
          [20, 28],
          [20, 30],
          [18, 30],
          [18, 28],
    
          [20, 28],
          [22, 28],
          [22, 30],
          [20, 30],
          [20, 28],
    
          [22, 28],
          [24, 28],
          [24, 30],
          [22, 30],
          [22, 28],
    
          [24, 28],
          [26, 28],
          [26, 30],
          [24, 30],
          [24, 28],
    
          [26, 28],
          [28, 28],
          [28, 30],
          [26, 30],
          [26, 28],
          [0, 28],
          [0, 0],
    
          [28, 0],
          [28, 2],
          [30, 2],
          [30, 0],
          [28, 0],
          [28, 2],
    
          [28, 4],
          [30, 4],
          [30, 2],
          [28, 2],
          [28, 4],
    
          [28, 6],
          [30, 6],
          [30, 4],
          [28, 4],
          [28, 6],
    
          [28, 8],
          [30, 8],
          [30, 6],
          [28, 6],
          [28, 8],
    
          [28, 10],
          [30, 10],
          [30, 8],
          [28, 8],
          [28, 10],
    
          [28, 14],
          [30, 14],
          [30, 12],
          [28, 12],
          [28, 14],
    
          [28, 16],
          [30, 16],
          [30, 14],
          [28, 14],
          [28, 16],
    
          [28, 18],
          [30, 18],
          [30, 16],
          [28, 16],
          [28, 18],
    
          [28, 20],
          [30, 20],
          [30, 18],
          [28, 18],
          [28, 20],
    
          [28, 22],
          [30, 22],
          [30, 20],
          [28, 20],
          [28, 22],
    
          [28, 26],
          [30, 26],
          [30, 24],
          [28, 24],
          [28, 26],
    
          [28, 28],
          [30, 28],
          [30, 26],
          [28, 26],
          [28, 28],
    
          [28, 30],
          [30, 30],
          [30, 28],
          [28, 28],
          [28, 30],
    
          [28, 32],
          [30, 32],
          [30, 30],
          [28, 30],
          [28, 32],
    
          [28, 34],
          [30, 34],
          [30, 32],
          [28, 32],
          [28, 34],
    
          [28, 0],
    
          [30, 0],
          [30, 28],
          [32, 28],
          [32, 30],
          [30, 30],
          [30, 28],
    
          [32, 28],
          [34, 28],
          [34, 30],
          [32, 30],
          [32, 28],
    
          [34, 28],
          [36, 28],
          [36, 30],
          [34, 30],
          [34, 28],
    
          [30, 28],
          [30, 0]      
        ]
    },
    'color-7': {
        name: 'Color 7',
        fillAll: true,
        placeholderColor: 'rgb(60,64,70)',
        border: [
            [0,0],
            [0, 34],
            [2, 34],
            [2, 36], 
            [0, 36], 
            [0, 34],
    
            [4, 34],
            [4, 36],
            [2, 36],
            [2, 34],
    
            [6, 34],
            [6, 36],
            [4, 36],
            [4, 34],
    
            [8, 34],
            [8, 36],
            [6, 36],
            [6, 34],
    
            [10, 34],
            [10, 36],
            [ 8, 36],
            [8, 34],
    
            [14, 34],
            [14, 36],
            [12, 36],
            [12, 34],
    
            [16, 34],
            [16, 36],
            [14, 36],
            [14, 34],
    
            [18, 34],
            [18, 36],
            [16, 36],
            [16, 34],
    
            [20, 34],
            [20, 36],
            [18, 36],
            [18, 34],
    
            [22, 34],
            [22, 36],
            [20, 36],
            [20, 34],
    
            [26, 34],
            [26, 36],
            [24, 36],
            [24, 34],
            
            [28, 34],
            [28, 36],
            [26, 36],
            [26, 34],
            
            [30, 34],
            [30, 36],
            [28, 36],
            [28, 34],
    
            [32, 34],
            [32, 36],
            [30, 36],
            [30, 34],
            
            [34, 34],
            [34, 36],
            [32, 36],
            [32, 34],
            [34, 34],
            [34, 0],
    
            [36, 0], 
            [36, 2], 
            [34, 2],
            [34, 0],
            [36, 0],
            
            [36, 2],
            [36, 4],
            [34, 4],
            [34, 2],
            [36, 2],
            [36, 4],
    
            [34, 4],
            [34, 8],
            [34, 6],
            [36, 6],
            
            [36, 8],
            [36, 10],
            [34, 10],
            [34, 8],
            [36, 8],
            
            [36, 10],
            [36, 12],
            [34, 12],
            [34, 10],
            [36, 10],
            
            [36, 12],
            [36, 14],
            [34, 14],
            [34, 12],
            [36, 12],
            
            [36, 14],
            [36, 16],
            [34, 16],
            [34, 14],
            [36, 14],
            
            [36, 16],
            [34, 16],
            [34, 20],
            [34, 18],
            [36, 18],
            
            [36, 20],
            [36, 22],
            [34, 22],
            [34, 20],
            [36, 20],
            
            [36, 22],
            [36, 24],
            [34, 24],
            [34, 22],
            [36, 22],
            
            [36, 24],
            [36, 26],
            [34, 26],
            [34, 24],
            [36, 24],
            
            [36, 26],
            [36, 28],
            [34, 28],
            [34, 26],
            [36, 26],
            
            [36, 28],
            [34, 28],
           
            [34, 30],
            [36, 30],
            [36, 32],
            [36, 34],
            [34, 34],
            [34, 32],
            [36, 32],
            [36, 34],
            [36, 36],
            [34, 36],
            [34, 34],
            [0, 34]
        ],
    }, 
}


// WEBPACK FOOTER //
// ./src/universal/filzfelt/blocks/plain-weave.js